import { SchemaElement } from '@/common/Types/SchemaElement';
import { ConnectorIds } from '@/common/constants';

export enum ConnectorType {
  CONNECTOR = 'CONNECTOR',
  UTILITY = 'UTILITY',
}

export enum ConnectorAuthTypes {
  OAUTH = 'oauth',
  BASIC = 'basic',
  JWT = 'jwt',
}

export type AuthConfigField = {
  fieldName: string;
  label: string;
  secret: boolean;
};

export interface IConnectorResource {
  endpoint: string;
  label: string;
  fields: SchemaElement[];
}

export interface IConnector {
  name?: string;
  description?: string;
  connectorId: ConnectorIds;
  authType?: ConnectorAuthTypes;
  isConnected?: boolean;
  authConfigFields?: AuthConfigField[];
  requiredApplicationFeatureSets?: string[];

  resources?: { [keys: string]: IConnectorResource };
  actions?: string[];

  type?: ConnectorType;
}
